/* FL: karta produktu (snippets/fl-kolekcja-karta.liquid) — kolekcje i (od 2026-10-25) każde miejsce z „Dodaj do koszyka”.
   - „Dodaj do koszyka” dodaje 1 szt., pomarańczowy przycisk paczki N szt. (/cart/add.js z quantity),
   - BEZ szuflady koszyka i bez okienek: zmienia się licznik w nagłówku, tekst na karcie
     i na chwilę przycisk („Dodano”); treść szuflady odświeża się po cichu, żeby była aktualna,
   - przycisk paczki i tekst pod ceną liczone ze stanu Shopify (data-flk-stan) i ilości produktu
     w koszyku (/cart.js), po załadowaniu strony i po każdej zmianie koszyka,
   - produkt w koszyku → zamiast przycisku paczki „Dodaj X szt. więcej / i otrzymaj mega zniżkę Y%”
     (atrybut data-flk-wiecej), a pod ceną „Masz super zniżkę Y% / oszczędzasz …”,
   - cały stan w koszyku → atrybut data-flk-maks na karcie (CSS pokazuje stały komunikat
     „W koszyku znajduje się już maksymalna ilość tego produktu.” w miejscu przycisku paczki). */
(function () {
  if (window.flKolekcjaKarta) return;
  window.flKolekcjaKarta = true;

  var NB = '\u00a0';
  var SEL = '[data-flk-card][data-flk-q]';
  var CHECK = '<svg class="flk-card__check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // grosze → „1.234,56 zł” (format sklepu: {{amount_with_comma_separator}} zł)
  function zl(gr, sp) {
    var s = (gr / 100).toFixed(2).split('.');
    return s[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + s[1] + (sp || NB) + 'zł';
  }

  function ok(txt) { return '<span class="flk-card__ok">' + txt + '</span>'; }

  // Stan karty przy q sztukach w koszyku — ta sama logika co Liquid w snippecie.
  // Pełna tabela progów „2:8,5:12,10:16”, ustalona paczka z tabeli w data-flk-paczka-max;
  // brak data-flk-stan = bez limitu (stan nieśledzony albo „sprzedawaj, gdy brak towaru”).
  function state(card, q) {
    var t = (card.dataset.flkProgiPelne || '').split(',').filter(Boolean).map(function (s) {
      return s.split(':').map(Number);
    });
    var stan = card.dataset.flkStan === undefined ? Infinity : Number(card.dataset.flkStan);
    var cena = Number(card.dataset.flkCena || 0);
    var max = Number(card.dataset.flkPaczkaMax) || Infinity;
    var cel = null, got = null, next = null;
    t.forEach(function (x) {
      if (x[0] <= stan && x[0] <= max) cel = x; // największy próg do ustalonej paczki, w granicach stanu
      if (x[0] <= q) got = x; else if (!next) next = x;
    });
    // rabat na sztuce jak DealEasy: w groszach w dół
    function rabat(x) { return Math.floor(cena * x[1] / 100); }
    // nazwa progu jak etykieta DealEasy, od góry tabeli: ostatni „giga”, przedostatni „mega”, wcześniejszy „super”
    function znizka(x) { var n = ['giga', 'mega', 'super'][t.length - 1 - t.indexOf(x)]; return (n ? n + ' ' : '') + 'zniżkę' + NB + x[1] + '%'; }
    // paczka tylko przy pustym koszyku (właściciel 2026-10-25: po „Dodaj do koszyka” drugi przycisk znika,
    // a w jego miejscu jest „Dodaj X szt. więcej / i otrzymaj {nazwa} zniżkę Y%”, jeśli następny próg pozwala stan)
    var pack = !q && cel && cel[0] >= 2 ? cel : null;
    var sav = '', more = '';
    if (pack) sav = ok('Zaoszczędzisz ' + zl(pack[0] * rabat(pack))) + '<br>przy zakupie ' + pack[0] + NB + 'szt.';
    if (q && got) {
      sav = ok('Masz' + NB + znizka(got)) + '<br>oszczędzasz ' + zl(q * rabat(got));
    }
    var maks = q > 0 && q >= stan;
    var txt = '';
    if (q && !maks && next && next[0] <= stan) {
      // przed pierwszym progiem (np. 1 szt.) ten tekst stoi pod ceną, potem w miejscu paczki (właściciel 2026-10-25)
      txt = ok('Dodaj ' + (next[0] - q) + NB + 'szt. więcej') + '<br>i otrzymaj ' + znizka(next);
      if (got) more = txt; else sav = txt;
    }
    // tryb „przyciski” (karty motywu poza kolekcjami): nic pod ceną; w miejscu paczki „Dodaj X szt. więcej …”,
    // a gdy wyższego progu nie ma (najwyższy osiągnięty albo blokuje stan) — „Masz … zniżkę / oszczędzasz …”
    if (card.dataset.flkTryb === 'przyciski') {
      more = (q && !maks) ? (txt || (got ? ok('Masz' + NB + znizka(got)) + '<br>oszczędzasz ' + zl(q * rabat(got)) : '')) : '';
      sav = '';
    }
    return { sav: sav, more: more, pack: pack, szt: pack ? cena - rabat(pack) : 0, maks: maks };
  }

  function paint(card, q, force) {
    if (!force && card.dataset.flkQ === String(q)) return;
    card.dataset.flkQ = q;
    var st = state(card, q);
    var el = card.querySelector('[data-flk-sav]');
    if (el && !el.dataset.flkErr) {
      el.innerHTML = st.sav;
      el.hidden = !st.sav;
    }
    var btn = card.querySelector('[data-flk-paczka]');
    // przycisk paczki w trakcie „Dodano” zostaje; miejsce pod zielonym przeliczy się po powrocie (added → repaint)
    if (btn && btn.dataset.flkDone) return;
    card.toggleAttribute('data-flk-maks', st.maks);
    var more = card.querySelector('[data-flk-wiecej-txt]');
    if (!card.dataset.flkErr) {
      if (more) more.innerHTML = st.more;
      card.toggleAttribute('data-flk-wiecej', !!st.more);
    }
    if (btn) {
      if (st.pack) {
        var n = st.pack[0];
        btn.dataset.flkAdd = n;
        btn.setAttribute('aria-label', 'Dodaj ' + n + ' szt. do koszyka, po ' + zl(st.szt, ' ') + ' za sztukę');
        var lab = btn.querySelector('[data-flk-lab]');
        if (lab) lab.innerHTML = n + NB + 'szt. po ' + zl(st.szt);
        else btn.innerHTML = '<span class="flk-card__lab">' + n + NB + 'szt. po ' + zl(st.szt) + '</span>';
      }
      if (btn.hasAttribute('data-flk-lab') || card.dataset.flkTryb === 'przyciski') {
        // tryb „przyciski”: przycisk paczki zostaje w układzie (miejsce na tekst), tylko niewidoczny
        btn.classList.toggle('flk-p--ukryty', !st.pack);
        if (st.pack) { btn.removeAttribute('aria-hidden'); btn.removeAttribute('tabindex'); }
        else { btn.setAttribute('aria-hidden', 'true'); btn.setAttribute('tabindex', '-1'); }
      } else {
        btn.hidden = !st.pack;
      }
    }
  }

  function repaint(card) {
    if (card.dataset.flkQ !== undefined) paint(card, Number(card.dataset.flkQ), true);
  }

  function quantities(cart) {
    var m = {};
    (cart.items || []).forEach(function (it) { m[it.product_id] = (m[it.product_id] || 0) + it.quantity; });
    return m;
  }

  // jedno zapytanie naraz; zmiana w trakcie → jeszcze jedno po nim (żeby nie zostać na starym koszyku)
  var busy = false, again = false;
  function sync() {
    if (!document.querySelector(SEL)) return;
    if (busy) { again = true; return; }
    busy = true;
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        var m = quantities(cart);
        document.querySelectorAll(SEL).forEach(function (card) {
          paint(card, m[card.dataset.productId] || 0);
        });
      })
      .catch(function () {})
      .then(function () {
        busy = false;
        if (again) { again = false; sync(); }
      });
  }

  // info = odmowa Shopify z powodu ilości (HTTP 422, np. „W koszyku znajduje się już maksymalna…”):
  // zielona jak reszta tekstów pod ceną; prawdziwy błąd (sieć, serwer) zostaje czerwony
  function showError(card, msg, info) {
    var html = '<span class="flk-card__err' + (info ? ' flk-card__err--info' : '') + '">' + esc(msg) + '</span>';
    if (card.dataset.flkTryb === 'przyciski') {
      // tryb „przyciski”: komunikat chwilowo w miejscu paczki
      var w = card.querySelector('[data-flk-wiecej-txt]');
      if (!w) return;
      card.dataset.flkErr = '1';
      w.innerHTML = html;
      card.setAttribute('data-flk-wiecej', '');
      setTimeout(function () { delete card.dataset.flkErr; repaint(card); sync(); }, 5000);
      return;
    }
    var el = card.querySelector('[data-flk-sav]');
    var temp = false;
    if (!el) {
      // karta bez progów: komunikat w pustym miejscu pod ceną (zostawionym dla równego rzędu)
      el = card.querySelector('.flk-card__sav');
      if (!el) {
        el = document.createElement('p');
        el.className = 'flk-card__sav';
        card.querySelector('.flk-card__acts').before(el);
      }
      temp = true;
    }
    el.dataset.flkErr = '1';
    el.hidden = false;
    el.removeAttribute('aria-hidden');
    el.innerHTML = '<span class="flk-card__err' + (info ? ' flk-card__err--info' : '') + '">' + esc(msg) + '</span>';
    setTimeout(function () {
      delete el.dataset.flkErr;
      if (temp) { el.innerHTML = ''; el.hidden = true; el.setAttribute('aria-hidden', 'true'); return; }
      repaint(card);
      sync();
    }, 5000);
  }

  function added(btn, card) {
    var html = btn.innerHTML;
    btn.dataset.flkDone = '1';
    btn.classList.add('flk-card__btn--done');
    // tryb „przyciski”: zmienia się tylko napis (klasy i rozmiar przycisku motywu zostają)
    var lab = card.dataset.flkTryb === 'przyciski' && btn.querySelector('[data-flk-lab]');
    if (lab) lab.innerHTML = CHECK + 'Dodano';
    else btn.innerHTML = '<span class="flk-card__lab">' + CHECK + 'Dodano</span>';
    setTimeout(function () {
      delete btn.dataset.flkDone;
      btn.innerHTML = html;
      btn.classList.remove('flk-card__btn--done');
      btn.removeAttribute('aria-disabled');
      repaint(card);
    }, 1200);
  }

  // licznik koszyka w nagłówku (jak product-form.js motywu) i treść szuflady — szuflada się NIE otwiera
  function renderCartUi(secs, drawer, drawerSection) {
    if (!secs) return;
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && secs['cart-icon-bubble']) bubble.innerHTML = secs['cart-icon-bubble'];
    if (drawer && drawerSection && typeof drawer.renderContents === 'function' &&
        secs[drawerSection.id.replace('shopify-section-', '')]) {
      drawer.renderContents({ sections: secs }, false);
    }
  }

  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest && evt.target.closest('[data-flk-add]');
    if (!btn) return;
    var card = btn.closest('[data-flk-card]');
    if (!card) return;
    evt.preventDefault();
    var qty = Number(btn.dataset.flkAdd);
    if (!qty || btn.hidden || btn.classList.contains('flk-p--ukryty') || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
    btn.setAttribute('aria-disabled', 'true');
    btn.classList.add('flk-card__btn--busy');

    var drawer = document.querySelector('cart-drawer');
    var drawerSection = drawer && drawer.closest('.shopify-section');
    var sections = ['cart-icon-bubble'];
    if (drawerSection) sections.push(drawerSection.id.replace('shopify-section-', ''));

    fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({
        items: [{ id: Number(card.dataset.flkVariant), quantity: qty }],
        sections: sections.join(','),
        sections_url: window.location.pathname
      })
    })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (data) {
          if (!r.ok) {
            var e = new Error(data.description || data.message || ('Błąd ' + r.status));
            e.status = r.status;
            throw e;
          }
          return data;
        });
      })
      .then(function (data) {
        btn.classList.remove('flk-card__btn--busy');
        added(btn, card);
        renderCartUi(data.sections, drawer, drawerSection);
        sync();
      })
      .catch(function (err) {
        btn.classList.remove('flk-card__btn--busy');
        btn.removeAttribute('aria-disabled');
        // przy całym stanie w koszyku ten sam komunikat już stoi na karcie — bez drugiego pod ceną
        if (!(err.status === 422 && card.hasAttribute('data-flk-maks'))) showError(card, err.message, err.status === 422);
        // Shopify przy braku stanu potrafi dodać część sztuk i zwrócić błąd — licznik i szuflada z serwera
        fetch(window.location.pathname + '?sections=' + sections.join(','), { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (secs) { if (secs) renderCartUi(secs, drawer, drawerSection); })
          .catch(function () {});
        sync();
      });
  });

  // tryb „przyciski” w formularzu motywu: Enter w polu ilości nie wysyła formularza motywu
  // (ten szukałby usuniętego przycisku name="add" i otwierał szufladę) — działa jak zielony przycisk
  document.addEventListener('submit', function (evt) {
    var card = evt.target && evt.target.querySelector && evt.target.querySelector('[data-flk-tryb="przyciski"]');
    if (!card) return;
    evt.preventDefault();
    evt.stopPropagation();
    var green = card.querySelector('[data-flk-add="1"]');
    if (green) green.click();
  }, true);

  // zmiany koszyka z innych miejsc (szuflada, inne formularze), zamknięcie szuflady,
  // powrót do strony z pamięci przeglądarki i do karty przeglądarki (koszyk mógł się zmienić gdzie indziej)
  ['on:line-item:change', 'on:cart:add', 'on:cart-drawer:after-close', 'on:bfcache:load-restore'].forEach(function (name) {
    document.addEventListener(name, function () { setTimeout(sync, 300); });
  });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') sync();
  });

  // karty dokładane później (rekomendacje, „Ostatnio oglądane”, bloki na stronie produktu, klony karuzeli,
  // pasek po zmianie wariantu): przeliczenie z koszykiem, jedno na całą paczkę zmian
  var later = null;
  function hasCard(node) {
    return node.nodeType === 1 && (node.matches('[data-flk-card]') || node.querySelector('[data-flk-card]'));
  }
  if ('MutationObserver' in window) {
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var added = list[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (hasCard(added[j])) {
            clearTimeout(later);
            later = setTimeout(sync, 150);
            return;
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  // przyklejony pasek na stronie produktu widoczny cały czas (właściciel 2026-10-25: „floating zawsze widoczny”):
  // strona dostaje odstęp na dole równy wysokości paska, żeby stopka i ostatnie sekcje nie chowały się pod nim
  function pasek() {
    var p = document.querySelector('sticky-atc-panel');
    if (!p) return;
    var set = function () { document.body.style.paddingBottom = p.offsetHeight ? p.offsetHeight + 'px' : ''; };
    set();
    if ('ResizeObserver' in window) new ResizeObserver(set).observe(p);
    window.addEventListener('resize', set);
  }

  function start() { sync(); pasek(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
